<template>
  <EventListComponent
    eventRoleList="user"
  />
</template>

<script>
import EventListComponent from '@/components/Tables/EventListComponent'
import {UserInfo} from '@/controllers/UserInfo';


export default {
  name: 'EventList',
  created() {
  },

  mounted() {

  },

  updated() {

  },

  methods: {},

  computed: {

  },

  components: {
    EventListComponent
  },

  data() {
    return {

    }
  },

  watch: {
    // '$route'(to, from) {
    //   if(to.name === 'EventList') {
    //     this.eventRole = 'user'
    //     console.log('1')
    //   }
    //   else if(to.name === 'EventListAdmin') {
    //     this.eventRole = 'admin'
    //     console.log('2')
    //   }
    // }

  }
}
</script>